<template>
    <div class="graduationProveTable">
        <div class="graduationProveTable-box">
            <div class="search">
                <el-form
                    ref="search"
                    :inline="true"
                    :model="condition"
                    :rules="rules"
                    label-width="80px"
                    style="display: flex; justify-content: space-between"
                >
                    <div>
                        <!-- <el-form-item>
                            <el-input v-model="condition.student_code" placeholder="请输入学号" clearable></el-input>
                        </el-form-item> -->
                        <el-form-item prop="identity">
                            <el-input v-model="condition.identity" placeholder="请输入身份证" clearable></el-input>
                        </el-form-item>
                        <!-- <el-form-item>
                            <el-input v-model="condition.candidate_number" placeholder="请输入考生号" clearable></el-input>
                        </el-form-item> -->
                        <el-form-item>
                            <el-button type="primary" @click="loadData">搜索</el-button>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <el-table
                v-if="isShowTable"
                :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
                :data="tableData"
                border
                style="width: 100%;margin-top: 20px;"
            >
                <el-table-column prop="student_title" align="center" label="学生姓名"></el-table-column>
                <el-table-column prop="identity" align="center" label="身份证"></el-table-column>
                <el-table-column prop="student_code" align="center" label="学号"></el-table-column>
                <el-table-column prop="candidate_number" align="center" label="考生号"></el-table-column>
                <el-table-column prop="school_title" align="center" label="函授站"></el-table-column>
                <el-table-column prop="class_title" align="center" label="班级名称"></el-table-column>
                <el-table-column prop="level_title" align="center" label="学制层次"></el-table-column>
                <el-table-column prop="tel" align="center" label="联系电话"></el-table-column>
                <el-table-column prop="old_cert_code" align="center" label="原毕业证书编号"></el-table-column>
                <el-table-column prop="entrance_date" align="center" label="入学时间"></el-table-column>
                <el-table-column prop="grad_date" align="center" label="毕业时间"></el-table-column>
                <el-table-column prop="shape_title" align="center" label="学习形式"></el-table-column>

                <el-table-column prop="apply_remark" align="center" label="申请原因"></el-table-column>
                <el-table-column prop="card_img_just" label="身份证正面照(人像面)" align="center">
                    <template v-slot="{row}">
                        <el-image 
                            v-if="row.card_img_just ? true : false"
                            class="see-img"
                            :src="row.card_img_just" 
                            fit="contain"
                            :preview-src-list="[row.card_img_just]">
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="card_img_back" label="身份证反面照(国徽面)" align="center">
                    <template v-slot="{row}">
                        <el-image 
                            v-if="row.card_img_back ? true : false"
                            class="see-img"
                            :src="row.card_img_back" 
                            fit="contain"
                            :preview-src-list="[row.card_img_back]">
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="archives_img" label="学籍档案照片" align="center">
                    <template v-slot="{row}">
                        <el-image 
                            v-if="row.archives_img ? true : false"
                            class="see-img"
                            :src="row.archives_img" 
                            fit="contain"
                            :preview-src-list="[row.archives_img]">
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="inch_img" label="证件照" align="center">
                    <template v-slot="{row}">
                        <el-image 
                            v-if="row.inch_img ? true : false"
                            class="see-img"
                            :src="row.inch_img" 
                            fit="contain"
                            :preview-src-list="[row.inch_img]">
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="apply_img" label="申请书照片" align="center">
                    <template v-slot="{row}">
                        <el-image 
                            v-if="row.apply_img ? true : false"
                            class="see-img"
                            :src="row.apply_img" 
                            fit="contain"
                            :preview-src-list="[row.apply_img]">
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="is_check" align="center" label="审核状态">
                    <template slot-scope="{ row }">
                        <el-tag :type="row.is_check | isCheckStyle">
                            {{ row.is_check | isCheckFilter }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="check_at" align="center" label="申请原因"></el-table-column>
                <el-table-column prop="check_user_title" align="center" label="审核人"></el-table-column>
                <el-table-column prop="check_at" align="center" label="审核时间"></el-table-column>
                <el-table-column prop="check_remark" align="center" label="审核备注"></el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
import {studentPaGet} from '@/api/graduationProve';
export default {
    name: 'graduationProveTable',
    filters: {
        // 审核状态
        isCheckFilter(v){
            let obj = {
                0: '待审核',
                1: '已通过', 
                2: '未通过', 
            };
            return obj[v];
        },
        // 审核状态 样式
        isCheckStyle(v){
            let obj = {
                0: '', 
                1: 'success', 
                2: 'danger', 
            };
            return obj[v];
        },
    },
    data(){
        return {
            tableData: [],
            isShowTable: false,
            condition: {
                // student_code: '',  //学号
                identity: '', //身份证
                // candidate_number: '',  //考生号
            },
            rules: {
                identity: [{ required: true, message: '请输入身份证', trigger: 'blur' }],
            },
        };
    },
    created(){
        // this.getdata(); 
    },
    methods: {
        loadData(){
            this.$refs['search'].validate((valid) => {
                if (valid) {
                    this.getdata();
                }
            });
        },
        getdata(){
            let data = this.condition;
            studentPaGet(data).then(res => {
                if(res.code == 200){
                    this.tableData = res.result;
                    this.isShowTable = true;
                }
            });
        },       
    },
}
</script>

<style lang="scss" scoped>
.graduationProveTable{
    padding: 20px;
    height: 100vh;
    overflow-y: auto;
    .graduationProveTable-box{
        background-color: #fff;
        padding: 20px;
    }
}
</style>